import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import {
  getInstrument,
  updatecalibrationApi,
} from "../../../services/CalibrationService";
import { StaticSelectInput } from "../../constant/SelectInput";

const EditCalibration = ({ data, handleAfterUpdate, user }) => {
  const [dataInput, setDataInput] = useState({
    calibration_name: "",
    description: "",
    schedule_at: "",
    instrument_ids: [],
  });
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [instrument, setInstrument] = useState([]);

  useEffect(() => {
    const fetchInstrument = async () => {
      try {
        const resp = await getInstrument();
        setInstrument(resp.data.data);
      } catch (error) {
        console.error("Error fetching divisions:", error);
      }
    };

    fetchInstrument();
  }, []);

  useEffect(() => {
    if (data) {
      const instruments = data.instruments
        ? data.instruments.map((item) => item.id)
        : [];

      setDataInput({
        calibration_name: data.name || "",
        description: data.description || "",
        schedule_at: data.scheduled_at || "",
        instrument_ids: instruments,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "photo") {
      setDataInput((prevDataInput) => ({
        ...prevDataInput,
        photo: files[0],
      }));
    } else {
      setDataInput((prevDataInput) => ({
        ...prevDataInput,
        [name]: value,
      }));
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setDataInput({
      calibration_name: data?.name || "",
      description: data?.description || "",
      schedule_at: data?.scheduled_at || "",
      instrument_ids: data?.instruments
        ? data.instruments.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        : [],
    });
    setErrors({});
    setShowModal(false);
  };

  const handleSelectChange = (name, value) => {
    setDataInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {

    try {
      setIsSubmitLoading(true);
      const date = new Date(dataInput.schedule_at);
      const formattedScheduleAt = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;

      const payload = {
        ...dataInput,
        schedule_at: formattedScheduleAt,
      };

      const response = await updatecalibrationApi(data.id, payload);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      {data.created_by?.id === user?.id && data?.status === "pending" && (
        <div>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={openModal}
          >
            <i className="fa-solid fa-pen-to-square"></i> Edit
          </button>
        </div>
      )}

      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Calibration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mb-2">
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Title<span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  placeholder="Enter Title"
                  name="calibration_name"
                  value={dataInput.calibration_name}
                  onChange={handleChange}
                />
                {errors.calibration_name && (
                  <div className="text-danger">{errors.calibration_name}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Schedule At<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="schedule_at"
                  value={dataInput.schedule_at}
                  onChange={handleChange}
                />
                {errors.schedule_at && (
                  <div className="text-danger">{errors.schedule_at}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <StaticSelectInput
                  setParentInputValue={handleSelectChange}
                  optionsList={instrument.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  name="instrument_ids"
                  id="instrument_ids"
                  isClearable
                  placeholder="Select Instrument"
                  label="Instrument"
                  is_multi={true}
                  isRequired={true}
                  defaultValue={data.instruments.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                />
                {errors.instrument_ids && (
                  <div className="text-danger">{errors.instrument_ids}</div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group mb-3">
                <label className="form-label">
                  Description<span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="description"
                  value={dataInput.description}
                  onChange={handleChange}
                ></textarea>
                {errors.description && (
                  <div className="text-danger">{errors.description}</div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-start">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading}
            >
              {isSubmitLoading ? "Updating..." : "Update"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth?.user,
});
export default connect(mapStateToProps)(EditCalibration);
